import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HashLocationStrategy, PathLocationStrategy} from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { ServicesComponent } from './services/services.component';
import { WorkComponent } from './work/work.component';
import { BlogComponent } from './blog/blog.component';
import { ContactComponent } from './contact/contact.component';
import { NavbarComponent } from './navbar/navbar.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { LoginComponent } from './login/login.component';
import { NotfoundComponent } from './notfound/notfound.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomFormsModule } from 'ngx-custom-validators';
// 1. Import the libs you need
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { environment } from '../environments/environment';
import { RegisterComponent } from './register/register.component';
import { UsersComponent } from './adminPage/users/users.component';
import { DashboardComponent } from './adminPage/dashboard/dashboard.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { DataTableModule } from 'angular5-data-table';
// 2. Import services
import { AuthService } from './serv/auth.service';
import { AuthGuardService } from './serv/auth-guard.service';
import { AdminComponent } from './adminPage/admin/admin.component';
import { TopbarComponent } from './adminPage/topbar/topbar.component';
import { FooterComponent } from './adminPage/footer/footer.component';
import { SidebarComponent } from './adminPage/sidebar/sidebar.component';
import { ProfileComponent } from './profile/profile.component';
import { DocumentationComponent } from './documentation/documentation.component';
import { SettingsComponent } from './settings/settings.component';
import { UserService } from './serv/user.service';
import { AdminAuthGuardService } from './serv/admin-auth-guard.service';
import { from } from 'rxjs';
import { ContactService } from './serv/contact.service';
import { ShowContactComponent } from './adminPage/contacts/show-contact/show-contact.component';




@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutComponent,
    ServicesComponent,
    WorkComponent,
    BlogComponent,
    ContactComponent,
    NavbarComponent,
    TestimonialsComponent,
    LoginComponent,
    NotfoundComponent,
    RegisterComponent,
    UsersComponent,
    DashboardComponent,
    ForgotPasswordComponent,
    AdminComponent,
    TopbarComponent,
    FooterComponent,
    SidebarComponent,
    ProfileComponent,
    DocumentationComponent,
    SettingsComponent,
    ShowContactComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    CustomFormsModule,
    NgbModule,
    AngularFireModule.initializeApp(environment.firebase),
    DataTableModule.forRoot(),
    AngularFirestoreModule, // firestore
    AngularFireAuthModule, // auth
    AngularFireStorageModule, NgbModule,// storage
    AngularFireDatabaseModule,
  
  ],
  providers: [AuthService, AuthGuardService, AdminAuthGuardService, UserService, ContactService,PathLocationStrategy , HashLocationStrategy],
  bootstrap: [AppComponent]
})
export class AppModule { }
